import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
